import { useToast } from "../shared/components/toast/useToast";
import { CircleCheck, TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

const useToastWrapper = () => {
  const { toast } = useToast();
  const { t } = useTranslation();

  const SuccessToast = (text) => (
    <div className="flex flex-row gap-x-1 items-center">
      <CircleCheck color="#14b817" />
      {text}
    </div>
  );

  const ErrorToast = (text) => (
    <div className="flex flex-row gap-x-1 items-center">
      <TriangleAlert />
      {text}
    </div>
  );

  return {
    success: (text) => {
      toast({ description: SuccessToast(text) });
    },
    warning: (text) => {
      toast({
        title: "Acción no permitida",
        description: text,
        variant: "destructive",
      });
    },
    error: (text) => {
      toast({
        title: "Error encountered",
        description: ErrorToast(text),
        variant: "destructive",
      });
    },
    usersWarning: () => {
      toast({
        title: "AVISO",
        description:
          "Debido a un problema con el pipeline esta mañana, algunos datos de ayer no se procesaron completamente. Todos los datos estarán disponibles en 3 horas. Gracias por su paciencia.",
        variant: "destructive",
      });
    },
    displayUnexpectedError: () => {
      toast({
        variant: "destructive",
        title: t("common.unexpectedErrorTitle"),
        description: t("common.unexpectedErrorDescription"),
      });
    },
    displayError: (error) => {
      toast({
        variant: "destructive",
        title: t("common.unexpectedErrorTitle"),
        description: error,
      });
    },
    display: (title, description) => {
      toast({
        title: t(title),
        description: t(description),
        duration: 2000,
      });
    },
  };
};

export default useToastWrapper;
